import React from 'react';
import { ArrowDirection } from '@sales-portal/domain/pricing/screens/management/types';
import { createStyles } from '@/contexts/theme-context';
import { getDeltaAttributes } from '@sales-portal/domain/pricing/screens/management/blocs/utils/table-ui';
import { Typography } from '@usepepper/ui/atoms/typography';
import { View } from 'react-native';

interface PricingTableDeltaCellProps {
  arrowDirection?: ArrowDirection;
  hasInvertedColor?: boolean;
  hideDeltaAttributes?: boolean;
  value: string;
}

export const PricingTableDeltaCell: React.FC<PricingTableDeltaCellProps> = ({
  arrowDirection,
  hasInvertedColor = false,
  hideDeltaAttributes = false,
  value,
}) => {
  const [styles, theme] = useStyles();

  const { Icon, color } = getDeltaAttributes(
    arrowDirection,
    theme,
    hasInvertedColor,
  );

  return (
    <View style={styles.container}>
      <Typography variant="paragraph-md">
        {`${arrowDirection === ArrowDirection.Up ? '+' : ''}${value}`}
      </Typography>
      {hideDeltaAttributes ? null : (
        <View style={styles.deltaIconContainer}>
          {Icon ? (
            <Icon fill={color} height={8} stroke={color} width={8} />
          ) : null}
        </View>
      )}
    </View>
  );
};

const useStyles = createStyles((_theme) => ({
  container: {
    alignItems: 'center',
    flexDirection: 'row',
  },
  deltaIconContainer: {
    alignItems: 'center',
    minWidth: 12,
  },
}));
